import React from 'react';
import { Link } from 'react-router-dom';
import { Table, Button } from 'react-bootstrap';
import { ISiteListProps, ISiteListItem } from './types';

const SiteList: React.FC<ISiteListProps> = ({
  sites,
  onActivate,
  onDeactivate,
  onReloadSite,
}) => {
  const renderListItem = (site: ISiteListItem) => (
    <tr key={site.pin}>
      <td>
        {site.deactivated ? (
          site.pin
        ) : (
          <Link to={`/admin/sites/${site.pin}`}>{site.pin}</Link>
        )}
      </td>
      <td>{site.name}</td>
      <td>
        {!site.deactivated && (
          <Link to={`/admin/sites/${site.pin}/password`}>Change Password</Link>
        )}
      </td>
      <td>
        {!site.deactivated && (
          <Link to={`/admin/sites/${site.pin}/poster`}>Print Poster</Link>
        )}
      </td>
      <td>
        <Button
          type="button"
          variant={site.deactivated ? 'success' : 'danger'}
          size="sm"
          onClick={() =>
            site.deactivated ? onActivate(site.pin) : onDeactivate(site.pin)
          }
        >
          {site.deactivated ? 'Activate' : 'Deactivate'}
        </Button>
      </td>
      <td>
        {!site.deactivated && (
          <Button
            type="button"
            size="sm"
            onClick={() => onReloadSite(site.pin)}
          >
            Reload Clients
          </Button>
        )}
      </td>
    </tr>
  );

  return (
    <Table hover responsive>
      <thead>
        <tr>
          <th>PIN</th>
          <th>Name</th>
          <th />
          <th />
          <th />
          <th />
        </tr>
      </thead>
      <tbody>{sites.map(renderListItem)}</tbody>
    </Table>
  );
};

export default SiteList;
